import EcotaxCreateForm from './create/eco-form';
import EcotaxUpdateForm from './update/eco-form';
import {MODAL} from 'features/modal-notch/constants';

export default {
  [MODAL.ECOTAX_CREATE]: EcotaxCreateForm,
  [MODAL.ECOTAX_UPDATE]: EcotaxUpdateForm,
};
